function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M11.576,13.485H7.985V9.894H5.591v3.591H2v2.394H5.591V19.47H7.985V15.879h3.591Zm9.97,1.2a3.591,3.591,0,1,0-1.089-7.014,5.906,5.906,0,0,1,1.077,3.423,6.022,6.022,0,0,1-1.077,3.423A3.579,3.579,0,0,0,21.545,14.682Zm-5.985,0a3.591,3.591,0,1,0-3.591-3.591A3.576,3.576,0,0,0,15.561,14.682Zm7.924,2.585a4.429,4.429,0,0,1,1.652,3.4v2.394h3.591V20.667C28.727,18.823,25.89,17.686,23.484,17.267Zm-7.924-.192c-2.394,0-7.182,1.2-7.182,3.591v2.394H22.742V20.667C22.742,18.273,17.954,17.076,15.561,17.076Z",
  transform: "translate(-2 -7.5)"
});

function SvgParticipants(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.727,
    height: 15.561,
    viewBox: "0 0 26.727 15.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipants);
export default __webpack_public_path__ + "static/media/participants.d19a6e8a.svg";
export { ForwardRef as ReactComponent };